export const layoutAdapter = (prismicDoc) => {
  const requestData = prismicDoc.data;

  const headerData = {
    countryCode: requestData["country-code"] || "",
    logoAltText: requestData["header-logo"].alt || "",
    logoUrl: requestData["header-logo"].url,
  };

  const footerData = {
    companyName: requestData["company-name"] || "",
    metaLinks: requestData["meta-links"].map((link) => ({
      type: link.type || "URL",
      title: link.title || "",
      url: link.url?.url || "",
    })),
    socialLinks: requestData["social-links"].map((link) => ({
      imageUrl: link.image.url,
      imageAltText: link.image.alt || "",
      icon: link.icon || null,
      tooltip: link.tooltip || "",
      url: link.url.url,
    })),
  };

  return {
    headerData,
    footerData,
  };
};
